import React from 'react';
import { useIntercom } from '../../hooks/useIntercom';
import Header from './Header';
import Hero from './Hero';
import Showcase from './Showcase';
import Features from './Features';
import Integrations from './Integrations';
import Comparison from './Comparison';
import TrustSection from './TrustSection';
import ImprovementLoop from './ImprovementLoop';
import HowItWorks from './HowItWorks';
import DemoVideos from './DemoVideos';
import Pricing from './Pricing';
import CTA from './CTA';
import ContactSection from './ContactSection';
import About from './About';
import Footer from './Footer';

const LandingPage = ({ onNavigateLogin }) => {
  useIntercom();
  return (
    <div className="min-h-screen flex flex-col">
      <Header onNavigateLogin={onNavigateLogin} />
      <Hero onNavigateLogin={onNavigateLogin} />
      <Showcase />
      <Features />
      <Integrations />
      <Comparison />
      <TrustSection />
      <ImprovementLoop />
      <HowItWorks />
      <DemoVideos />
      <Pricing onNavigateLogin={onNavigateLogin} />
      <CTA onNavigateLogin={onNavigateLogin} />
      <ContactSection />
      <About />
      <Footer />
    </div>
  );
};

export default LandingPage;
